// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_yEk","cls2":"LoggedOutDiscoveryPage-cls2_8o3 LoggedOutDiscoveryPage-cls1_yEk"};